module.exports = __webpack_public_path__ + "static/img/good6.ad1bf89a.png";